import { EmployeeData } from './types';

/** Display precedence for the Overview employee count: exact total → legacy range → legacy count. Returns undefined when none present. */
export function getDisplayEmployeeCount(employeeData?: EmployeeData): string | number | undefined {
    return employeeData?.totalEmployeeCount ?? employeeData?.currentEmployeeRange ?? employeeData?.currentEmployeeCount;
}
